import { proxy } from 'valtio';

/**
 * Global auth-modal state. Any component can trigger the sign-in / sign-up
 * modal by calling openAuth() — no prop drilling, no navigation to a separate
 * page. The single <AuthModal /> mounted in Router subscribes to this.
 */
export type AuthMode = 'login' | 'register';

export const authModalStore = proxy<{ open: boolean; mode: AuthMode }>({
  open: false,
  mode: 'login',
});

export function openAuth(mode: AuthMode = 'login') {
  authModalStore.mode = mode;
  authModalStore.open = true;
}

export function closeAuth() {
  authModalStore.open = false;
}
